const PersonalCenter = r => require.ensure([], () => r(require('@/page/PersonalCenter/PersonalCenter')), 'PersonalCenter');
const baseConfig = r => require.ensure([], () => r(require('@/page/PersonalCenter/baseConfig/baseConfig')), 'baseConfig');
const otherMore = r => require.ensure([], () => r(require('@/page/PersonalCenter/more/otherMore')), 'otherMore');
const changePassword = r => require.ensure([], () => r(require('@/components/container/changePassword.vue')), 'changePassword');

const PersonalCenterRouter = {
  path: '',
  component: PersonalCenter,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: false,
  },
  name: '个人中心',
  redirect: '/baseConfig',
  children: [{
    path: '/baseConfig',
    component: baseConfig,
    name: '个人中心',
    meta: {
      name: '用户信息',
      right: ['用户信息'],
      isShowMenu: true
    },
  }, {
    path: '/otherMore',
    component: otherMore,
    name: '个人中心',
    meta: {
      name: '机构信息',
      right: ['机构信息'],
      isShowMenu: false
    },
  },
    {
      path: '/changePassword',
      component: changePassword,
      name: '个人中心',
      meta: {
        name: '修改密码',
        right: ['修改密码'],
        isShowMenu: false
      }
    }
  ]
};

export default PersonalCenterRouter;